<template>
	<div class="plug-tree">
		<div class="topCut" >
			<span class="title">{{title?title:'是否查询下级'}}</span>
			<span v-if="showSwitch">
				<el-tooltip :content="'当前查询状态: ' + newSwitchVal?'查询下级区域':'查询本级区域'" placement="top">
					<el-switch @change="changeSwitch" v-model="newSwitchVal" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-tooltip>
			</span>
		</div>
		<div style="overflow: auto;height:100%">
			<el-tree :props="props" ref="nodeTree" :current-node-key="nodeId"    node-key="id" @node-click="nodeClick" :load="loadNode" lazy> </el-tree>
		</div>
	</div>
</template>

<script>
	import publicAPI from '../../api-path/public-api'
	export default {
		name: "tree",
		props: {
			switchVal: {
				type: Boolean,
				default: false
			},
			showSwitch: {
				type: Boolean,
				default: true,
			},
			title: {
				type: String,
				default: '是否查询下级',
			}
		},
		data() {
			return {
				newSwitchVal: false,
				areaTreeList:[],
				nodeId:'0',
				props: {
					label: 'newName',
					key: 'id',
					children: 'areaTreeListResList',
					isLeaf: 'isLast'
				},
			}
		},
		created() {
			if (this.switchVal) {
				this.newSwitchVal = this.switchVal === this.newSwitchVal ? this.newSwitchVal : this.switchVal
			}
		},
		methods: {
			loadNode(node, resolve) {
				let $this=this;
				if (node.level === 0) {
					$this.$http.get(publicAPI.areaListTree).then(res => {
						if (res.status==200) {
							$this.areaTreeList=res.result.areaTreeListResList;
							setTimeout(function () {
								$this.$nextTick(function () {
									this.nodeId=res.result.id;
									$this.$refs.nodeTree.setCurrentKey()
									$this.$emit('nodeClick', res.result)
								})
							},1500)
							return resolve($this.changeValue([res.result],1));
						}
					})
				}
				if (node.level ==1) {
					return resolve(this.areaTreeList);
				}
				if (node.level > 1) {
					this.loadchildnode(node, resolve);
				}
			},
			loadchildnode(node, resolve) {
				let $this=this;
				this.$http.get(publicAPI.areaListTree, {
					params: { id: node.data.id }
				}).then(res => {
					if (res.status==200) {
						return resolve($this.changeValue(res.result.areaTreeListResList,2));
					}
				})
			},
			changeSwitch(e) {
				this.$emit('changeSwitch', e)
			},
			nodeClick(node) {
				this.$emit('nodeClick', node)
			},
			changeValue(dataArray,type){
				if(type==1){
					dataArray.map(item=>{
						item.newName=`${item.name}${item.setHotArea?'(已设置)':'(未设置)'}`
					});
					dataArray[0].areaTreeListResList.map(item=>{
						item.newName=`${item.name}${item.setHotArea?'(已设置)':'(未设置)'}`
					})
				}else{
					dataArray.map(item=>{
						item.newName=`${item.name}${item.setHotArea?'(已设置)':'(未设置)'}`
					});
				}
				return dataArray;
			}
		}
	}
</script>

<style lang="less" scoped>
	.plug-tree {
		width: 260px;
		height: 100%;
		.topCut {
			display: flex;
			padding: 5px;
			flex-direction: row;
			justify-content: space-between;
			height: 30px;
			background: #e3f7fc;
			color: #666;
			line-height: 30px;
			text-align: center;
			font-size: 14px;
			.title{
				width: 100%;
				text-align: center;
				display: inline-block;
			}
		}
	}
</style>
